import Login from "../components/Account/sign up & in/Login";

const Logins = (props) => {
  return (
    <Login
      error={props.error}
      onLogin={props.onLogin}
      isLoading={props.isLoading}
      loading={props.loading}
    />
  );
};

export default Logins;
